import { formatTaxLineDetail, getTaxLines } from '../tax';
import { Checkout } from '../../types';

const base = {
  tax_amount: 1200,
  tax_display_amount: '$12.00',
  tax_label: 'Tax',
  tax_percent: 12,
} as Checkout;

describe('getTaxLines', () => {
  it('renders one row per breakdown entry, using the entry label', () => {
    const lines = getTaxLines({
      ...base,
      tax_breakdown: [
        { tax_rate: 5, tax_label: 'GST', taxable_amount: 10000, tax_amount: 500, tax_display_amount: '$5.00', taxable_display_amount: '$100.00' },
        { tax_rate: 7, tax_label: 'PST', taxable_amount: 10000, tax_amount: 700, tax_display_amount: '$7.00', taxable_display_amount: '$100.00' },
      ],
    });

    expect(lines).toEqual([
      { label: 'GST', rate: 5, amount: 500, display_amount: '$5.00', taxable_display_amount: '$100.00' },
      { label: 'PST', rate: 7, amount: 700, display_amount: '$7.00', taxable_display_amount: '$100.00' },
    ]);
  });

  it('falls back to the checkout label when an entry has none', () => {
    const lines = getTaxLines({
      ...base,
      tax_breakdown: [{ tax_rate: 12, tax_label: null, taxable_amount: 10000, tax_amount: 1200, tax_display_amount: '$12.00' }],
    });

    expect(lines[0].label).toBe('Tax');
  });

  it('drops zero-amount entries', () => {
    const lines = getTaxLines({
      ...base,
      tax_breakdown: [
        { tax_rate: 5, tax_label: 'GST', taxable_amount: 10000, tax_amount: 500, tax_display_amount: '$5.00' },
        { tax_rate: 0, tax_label: 'PST', taxable_amount: 0, tax_amount: 0, tax_display_amount: '$0.00' },
      ],
    });

    expect(lines).toHaveLength(1);
    expect(lines[0].label).toBe('GST');
  });

  it('falls back to the aggregate scalars when there is no breakdown', () => {
    expect(getTaxLines(base)).toEqual([{ label: 'Tax', rate: 12, amount: 1200, display_amount: '$12.00' }]);
    expect(getTaxLines({ ...base, tax_breakdown: [] })).toHaveLength(1);
  });

  it('returns nothing when there is no tax', () => {
    expect(getTaxLines({ ...base, tax_amount: 0 })).toEqual([]);
    expect(getTaxLines(undefined)).toEqual([]);
  });
});

describe('formatTaxLineDetail', () => {
  it('matches the platform receipt when the taxable base is known', () => {
    expect(formatTaxLineDetail({ label: 'GST', rate: 5, amount: 3695, display_amount: '$36.95', taxable_display_amount: '$739.00' })).toBe('(5% on $739.00)');
  });

  it('shows only the rate for the aggregate fallback', () => {
    expect(formatTaxLineDetail({ label: 'Tax', rate: 12, amount: 1200, display_amount: '$12.00' })).toBe('(12%)');
  });
});
